import axios from "axios"

export default async function getSerialNumberScanListing({
    enc,
    length,
    start,
    column,
    order,
}) {
    return new Promise((resolve, reject) => {
        axios
        .get(`/consumer/admin/api/v1/scan/${enc}/get-sn-user-scan`, {
            params: {
                length,
                start,
                column,
                order,
            },
        })
        .then((response) => resolve(response.data))
        .catch((error) => {
            return reject(error.response.data)
        })
    })
}
